<template>
<div class="app-footer ">
   <div class="row">
      <div class="col s12 yo-align-center white">
         Società Italiana di Malattie Genetiche Pediatriche e Disabilità
      </div>
   </div>
</div>
</template>

<script>

export default {
  name: 'site-footer',
  components: {
  }
}
</script>
<style>
.site-footer{
    
}
</style>
